import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { debtService } from '../services';

export function useDebtGoals() {
  return useQuery({
    queryKey: ['debtGoals'],
    queryFn: debtService.list,
  });
}

export function useDebtGoal(id) {
  return useQuery({
    queryKey: ['debtGoal', id],
    queryFn: () => debtService.get(id),
    enabled: !!id,
  });
}

export function useDebtPlan(id, enabled = true) {
  return useQuery({
    queryKey: ['debtPlan', id],
    queryFn: () => debtService.getPlan(id),
    enabled: !!id && enabled,
    refetchInterval: (data) => {
      const status = data?.state?.data?.plan?.status;
      return status === 'generating' ? 25000 : false;
    },
  });
}

export function useCreateDebtGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: debtService.create,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['debtGoals'] }),
  });
}

export function useUpdateDebtGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) => debtService.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['debtGoals'] }),
  });
}

export function useDeleteDebtGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: debtService.delete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['debtGoals'] }),
  });
}

export function useCompleteDebtGoal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: debtService.complete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['debtGoals'] }),
  });
}

export function useGenerateDebtPlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: debtService.generatePlan,
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ['debtPlan', id] });
      queryClient.invalidateQueries({ queryKey: ['debtGoals'] });
    },
  });
}
